import Cookies from "js-cookie";

export const handleRememberMe = (rememberMe, setRememberMe) => {
  Cookies.set("rememberMe", !rememberMe, { expires: 365, path: "/" });
  setRememberMe(!rememberMe);
};
